import { useGoogleLogin } from "@react-oauth/google";
import { NSARouterMakerResult } from "namirasoft-account-react";
import { NSButton } from "namirasoft-site-react";
import { AccountRoutes } from "../AccountRoutes";

interface GoogleLoginButtonProps extends NSARouterMakerResult { }

function GoogleLoginButton(props: GoogleLoginButtonProps)
{
    const login = useGoogleLogin({
        onSuccess: (res) =>
        {
            if (res.access_token)
                props.account.server.user.Google({
                    access_token: res.access_token,
                    client_id: null,
                    credential: null
                }).then(() =>
                {
                    props.url.redirect(AccountRoutes.Home, {});
                }).catch(() => { });
        },
        onError: (e) =>
        {
            if (e.error_description)
                props.notifier.onError(e.error_description);
        },
    });

    return (
        <NSButton
            title="Sign in with Google"
            icon={{
                src: "https://static.namirasoft.com/image/application/google/logo/base.png",
            }}
            onClick={{
                action: () => login(),
                showLoading: false,
            }}
            style={{ border: "1px solid rgba(3, 119, 255, 1)" }}
        />
    );
}

export default GoogleLoginButton;